import React from 'react';
import type { FolderTree } from '@/hooks/useFolders';
import { ScrollableFolderPath } from './ScrollableFolderPath';

interface BreadcrumbNavigationProps {
  /** Current folder path from root to current folder */
  folderPath: FolderTree[];
  /** Currently selected folder (null = All Files) */
  currentFolder: FolderTree | null;
  /** Handler when a folder in the breadcrumb is clicked */
  onFolderSelect: (folder: FolderTree | null) => void;
}

/**
 * Breadcrumb navigation component for folder paths.
 * Displays "All Files" as root, followed by the folder hierarchy.
 */
export const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({
  folderPath,
  currentFolder,
  onFolderSelect,
}) => {
  return (
    <nav className="min-w-0 flex-1 text-sm" aria-label="Breadcrumb">
      <ScrollableFolderPath>
        <button
          type="button"
          onClick={() => onFolderSelect(null)}
          className={`shrink-0 hover:text-blue-600 hover:underline transition-colors ${
            currentFolder === null ? "font-medium text-gray-900" : "text-gray-600"
          }`}
        >
          All Files
        </button>
        {folderPath.map((folder, index) => (
          <React.Fragment key={folder.guid || index}>
            <span className="mx-1.5 shrink-0 text-gray-400" aria-hidden="true">/</span>
            <button
              type="button"
              onClick={() => onFolderSelect(folder)}
              className={`shrink-0 hover:text-blue-600 hover:underline transition-colors ${
                index === folderPath.length - 1 ? "font-medium text-gray-900" : "text-gray-600"
              }`}
              title={folder.name}
            >
              {folder.name}
            </button>
          </React.Fragment>
        ))}
      </ScrollableFolderPath>
    </nav>
  );
};

export default BreadcrumbNavigation;
